import { palette } from "../../../theme/palette";

import { Text, View } from "../../Base";

export const DriverProfileAutocompleteMenuItem = ({
  isHighlighted,
  onMouseEnter,
  address,
}) => {
  const highlightStyle = {};
  if (isHighlighted) highlightStyle.backgroundColor = palette.veryLightGrey;
  return (
    <View
      key={address.id}
      style={{
        padding: "0.25rem 0.75rem",
        ...highlightStyle,
      }}
      onMouseEnter={onMouseEnter}
    >
      <Text>{address.fullAddress}</Text>
    </View>
  );
};
